import { TextTestID } from "@/constants/TestID";
import type { SwitchProps } from "@/ui/core/Switch";
import Switch from "@/ui/core/Switch";
import Text from "@/ui/core/Text";
import { HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface LabelWithSwitchProps extends SwitchProps {
  isDisabled?: boolean;
  label: string;
}

const LabelWithSwitch = ({
  isDefaultChecked,
  isDisabled,
  label,
  onCheckedChange,
  testID,
}: LabelWithSwitchProps) => {
  return (
    <HStack justifyContent="space-between">
      <Text testID={joinTestIDs(testID, TextTestID.Text)}>{label}</Text>
      <Switch
        isDefaultChecked={isDefaultChecked}
        isDisabled={isDisabled}
        onCheckedChange={onCheckedChange}
        testID={testID}
      />
    </HStack>
  );
};

export default LabelWithSwitch;
export type { LabelWithSwitchProps };
